<template>
    <div class="error-msg-wrap">
        <div class="error-msg ep-save">
            <h3>Discard your changes?</h3>
            <p>You have unsaved changes. If you leave now, they're lost.</p>
            <div class="ep-save-btns">
                <button type="button" class="btn-light" @click="$emit('keep')">Keep editing</button>
                <button type="button" class="btn" @click="$emit('discard')">Discard changes</button>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'EditorDiscardDialog',
    emits: [ 'keep', 'discard' ]
});
</script>
